import {DeliveryType} from '../types'

export function mapVerticalToDeliveryType(verticalName: string) {
  switch (verticalName) {
    case 'walking_courier':
    case 'express':
    case 'cargo':
    case 'courier':
      return DeliveryType.Express
    case 'ndd_self_pickup':
    case 'ndd_shipment':
      return DeliveryType.NDD
    case 'night':
    default:
      return DeliveryType.SDD
  }
}
